import apiClient from 'API/client';
import { API_ENDPOINTS } from 'API/endpoints';
import UI_MESSAGES from 'i18n/messages';

export const fetchAssignDefaultEntity = async (userId, entityId) => {
  try {
    const data = {
      userId,
      entityId
    };

    const response = await apiClient.post(API_ENDPOINTS.USER.ASSIGN_DEFAULT_ENTITY, data);

    if (response.status !== 200) {
      throw new Error(UI_MESSAGES.common.statusError('asignar entidad por defecto al usuario', response.status));
    }
    return response.data;
  } catch (error) {
    if (error.response) {
      console.error(UI_MESSAGES.logs.apiResponseError + ':', error.response.data);
    } else if (error.request) {
      console.error(UI_MESSAGES.logs.apiNetworkError + ':', error.request);
    } else {
      console.error(UI_MESSAGES.logs.apiGenericError + ':', error.message);
    }
    throw error;
  }
};

export default fetchAssignDefaultEntity;
